import { memo, useEffect, useState, useRef } from "react";
import searchicon from "../assets/images/search-lg-icon.svg";


const SearchBar = memo(({ accessCodeList, setCurrentPage, setAccessCoeList, filteredData, allData, isFilter,
    setIsClearFiltre,
    isClearFilters,

}) => {

    const [search, setSearch] = useState('')

    const [isFocus, setIsFocus] = useState(false)

    const debounceRef = useRef(null);

    const filterDataByAll = (val) => {
        console.log('amire');
        val = val.toLowerCase();



        let tr = val == "yes" ? true : val == "no" ? false : "";
        if (val.length > 0) {
            const fltr = allData?.filter((i) => {
                return (
                    i?.name?.toLowerCase().includes(val) ||
                    i?.emailId?.toLowerCase().includes(val) ||
                    i?.phoneNumber?.includes(val) ||
                    i?.educationLevel?.toLowerCase().includes(val) ||
                    i?.feildOfEducation?.toLowerCase().includes(val) ||
                    i?.roleName?.toLowerCase().includes(val) ||
                    i?.currentCompany?.toLowerCase().includes(val) ||
                    i?.currentIndustry?.toLowerCase().includes(val) ||
                    i?.expectedCTC?.toLowerCase().includes(val) ||
                    i?.percentage?.includes(val) ||
                    i?.primaryName?.toLowerCase().includes(val) ||
                    i?.secondaryName?.toLowerCase().includes(val) ||
                    i?.primaryMatch?.includes(val) ||
                    i?.secondaryMatch?.includes(val) ||
                    i?.dateOfCompletion?.includes(val) ||
                    i?.availableDate?.includes(val) ||
                    i?.noticePeriodBuyoption === tr ||
                    i?.personalityMatch?.toLowerCase().includes(val) ||
                    i?.applicationMatch?.toLowerCase().includes(val) ||
                    i?.round2?.toLowerCase().includes(val) ||
                    i?.status?.toLowerCase().includes(val) ||
                    i?.dateOfCompletion?.includes(val) ||
                    i?.currentLocation?.toLowerCase().includes(val) ||
                    i?.departmentName?.toLowerCase().includes(val) ||
                    i?.profile_1?.toLowerCase().includes(val) ||
                    i?.profile_2?.toLowerCase().includes(val) ||
                    i?.profile_3?.toLowerCase().includes(val)
                );
            });


            setCurrentPage(1)

            setAccessCoeList(fltr);
        } else {


            if (filteredData?.length) {
                setAccessCoeList(filteredData)

            } else if (isFilter) {
                setAccessCoeList(accessCodeList)
            } else {

                setAccessCoeList(allData);
            }
        }
    };


    useEffect(() => {

        if (isClearFilters) {
            setSearch('')
            filterDataByAll('')
        }
    }, [isClearFilters])

    useEffect(() => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            filterDataByAll(search);
        }, 300); // 👈 debounce delay

        return () => clearTimeout(debounceRef.current);
    }, [search]);



    return <div className="canLisIconBox ms-1 activeInAvtie d-flex align-items-center"
        style={isFocus ? { border: "1px solid var(--ff-color-focus-ring-blue)" } : {}}

    >

        <input
            type="text"
            className="border-0 search-input"
            style={{ width: "92%" }}
            value={search}
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            onChange={(e) => {
                setSearch(e.target.value);
            }}
        />
        <img src={searchicon} className="boxIcon" alt="Logo" />
    </div>

})

export default SearchBar